export default __webpack_public_path__ + "static/media/download-icon.d2095275.svg";